module.exports = __webpack_public_path__ + "static/media/home_page_archero_background@768.1aedbfbd.png";